<!--
 * @Description: 新手引导
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->

<template>
  <div class="user-popover" :style="popStyle" v-if="data.popoverVisible">
    <!--日程  -->
    <jw-popconfirm :popup-visible="data.dashVisible" position="rt" :class="['user-popover-popconfirm', data.cancelVisible ? 'popover-popconfirm' : '']" style="z-index: 2006" cancel-text="跳过" :ok-text="data.okTest" :on-before-ok="dashOnOk" :on-before-cancel="onCancel">
      <template #content>
        <p class="confirm-title">{{ data.dashMenuVoList.title }}</p>
        <p class="confirm-content">{{ data.dashMenuVoList.content }}</p>
      </template>
      <div class="arco-menu-inner" v-if="data.dashVisible">
        <div class="arco-menu-list">
          <div class="arco-menu-item" v-for="(item, index) in data.dashMenuVoList?.menus" :key="index">
            <span class="arco-menu-icon"><component :is="item.icon" /> </span>
            <span class="arco-menu-item-inner arco-menu-title">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </jw-popconfirm>
    <!-- 对象菜单 -->
    <jw-popconfirm :popup-visible="data.menuVosVisible" position="rt" :class="['user-popover-popconfirm', data.cancelVisible ? 'popover-popconfirm' : '']" :style="{ 'z-index': 2006 }" cancel-text="跳过" :ok-text="data.okTest" :on-before-ok="menuOnOk" :on-before-cancel="onCancel">
      <template #content>
        <p class="confirm-title">{{ data.entityMenuVoList.title }}</p>
        <p class="confirm-content">{{ data.entityMenuVoList.content }}</p>
      </template>
      <div class="arco-menu-inner" v-if="data.menuVosVisible" ref="menuInnerRef">
        <div class="arco-menu-list">
          <div class="arco-menu-item" v-for="(item, index) in data.entityMenuVoList?.menus" :key="index">
            <span class="arco-menu-icon"><component :is="item.icon" /> </span>
            <span class="arco-menu-item-inner arco-menu-title">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </jw-popconfirm>
    <!-- 工作日程 -->
    <jw-popconfirm :popup-visible="data.workVisible" position="rt" :class="['user-popover-popconfirm', data.cancelVisible ? 'popover-popconfirm' : '']" :style="{ 'z-index': 2006 }" cancel-text="跳过" :ok-text="data.okTest" :on-before-ok="WorkerOnOk" :on-before-cancel="onCancel">
      <template #content>
        <p class="confirm-title">{{ data.workMenuVoList.title }}</p>
        <p class="confirm-content">{{ data.workMenuVoList.content }}</p>
      </template>
      <div class="arco-menu-inner" v-if="data.workVisible" ref="menuInnerRef">
        <div class="arco-menu-list">
          <div class="arco-menu-item" v-for="(item, index) in data.workMenuVoList?.menus" :key="index">
            <span class="arco-menu-icon"><component :is="item.icon" /> </span>
            <span class="arco-menu-item-inner arco-menu-title">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </jw-popconfirm>
    <!-- 设置 -->
    <jw-popconfirm :popup-visible="data.setVisible" position="bottom" class="user-popover-popconfirm popover-popconfirm" :style="{ 'z-index': 2006 }" ok-text="完成" :on-before-ok="onCancel">
      <template #content>
        <p class="confirm-title">{{ data.settingMenuVoList.title }}</p>
        <p class="confirm-content">{{ data.settingMenuVoList.content }}</p>
      </template>
      <div class="arco-menu-setting-inner" v-if="data.setVisible">
        <icon-settings size="21" />
      </div>
    </jw-popconfirm>
  </div>
  <div class="new-user-guide-mask" v-if="data.maskVisible"></div>
</template>
<script setup>
import { useUserStore } from '@/store';
import { setLoginTimes } from '@/utils/auth';
import { computed, reactive, ref, onMounted } from 'vue';
const { userInfo } = useUserStore();
const props = defineProps({
  style: {
    //菜单样式
    require: true,
    type: Object,
    default: () => {
      return {};
    }
  }
});

const data = reactive({
  dashVisible: false,
  menuVosVisible: false,
  workVisible: false,
  maskVisible: false,
  popoverVisible: false,
  setVisible: false,
  cancelVisible: false, //不显示取消按钮
  okTest: '下一步',
  dashMenuVoList: {
    // 工作台菜单
    title: '工作台-数据看板',
    content: '在这里，可查看各项业务数据统计与图表',
    menus: [
      {
        title: '工作台',
        icon: 'icon-dashboard',
        code: 'workbench'
      }
    ]
  },
  entityMenuVoList: { title: '各业务菜单', content: '在这里，可进行整个销售业务流程的管理', menus: [] }, //对象菜单
  workMenuVoList: { title: '工作日程', content: '在这里，可查看日历、日程、通话、动态记录四个维度展现数据指标及明细列表', menus: [] }, //工作日程
  settingMenuVoList: { title: '设置中心', content: '在这里，可进行系统各项配置，例如：字段配置、页面视图&布局配置、审批配置、阶段流程配置等', menus: [] } //设置
});
const menuInnerRef = ref();
const popsStyle = reactive({ ...props.style, paddingTop: '0px', right: '', left: '0px', top: '60px' });
const popStyle = computed(() => {
  return Object.assign({
    ...popsStyle
  });
});
const app = document.querySelector('#app');
app.style.height = '100%';
app.style.overflow = 'hidden';
onMounted(() => {
  const builtInsMenuVos = userInfo.menus?.builtIns; //系统菜单
  const menuVos = userInfo?.menus?.menuVos; // 对象菜单
  builtInsMenuVos?.forEach((element) => {
    if (element.code == 'workbench') {
      //工作台
      // data.dashMenuVoList.menus.push({
      //   ...element,
      //   child: []
      // });
    }
    if (element.code == 'workSchedule') {
      //工作日程
      data.workMenuVoList.menus.push({
        ...element,
        child: []
      });
    }
    if (element.code == 'settings') {
      //设置
      data.settingMenuVoList.menus.push({
        ...element,
        child: []
      });
    }
  });

  menuVos?.forEach((element) => {
    if (element && element.group && element?.child.length > 0) {
      //分组
      data.entityMenuVoList.menus.push({
        ...element,
        title: element.name,
        icon: element.child[0]?.resource?.icon
      });
    }
    if (element && !element.group) {
      //非分组
      data.entityMenuVoList.menus.push({
        ...element,
        title: element.name,
        icon: element?.resource?.icon
      });
    }
  });
  data.maskVisible = false;
  data.popoverVisible = false;
  //首次登陆-能进来必定有菜单权限
  data.maskVisible = true;
  data.popoverVisible = true;
  data.okTest = '下一步';
  if (data.dashMenuVoList.menus.length > 0) {
    //有工作台
    data.dashVisible = true;
    if (data.entityMenuVoList.menus.length == 0 && data.workMenuVoList.menus.length == 0 && data.settingMenuVoList.menus.length == 0) {
      data.okTest = '完成';
      data.cancelVisible = true;
    }
  } else {
    //没有工作台
    if (data.entityMenuVoList.menus.length > 0) {
      //对象菜单
      data.menuVosVisible = true;
      if (data.workMenuVoList.menus.length == 0 && data.settingMenuVoList.menus.length == 0) {
        data.okTest = '完成';
        data.cancelVisible = true;
      }
    } else {
      if (data.workMenuVoList.menus.length > 0) {
        //日程
        data.workVisible = true;
        if (data.settingMenuVoList.menus.length == 0) {
          data.okTest = '完成';
          data.cancelVisible = true;
        }
      } else {
        if (data.settingMenuVoList.menus.length > 0) {
          //设置
          popsStyle.top = '7px';
          popsStyle.right = '248px';
          popsStyle.left = 'auto';
          popsStyle.width = '45px';
          data.setVisible = true;
        }
      }
    }
  }
});
// 工作台点击下一步/完成
const dashOnOk = () => {
  if (data.okTest == '完成') {
    //完成
    onCancel();
  } else {
    data.dashVisible = false;
    if (data.entityMenuVoList.menus.length > 0) {
      //对象菜单
      popsStyle.top = '100px';
      data.menuVosVisible = true;
      if (data.workMenuVoList.menus.length == 0 && data.settingMenuVoList.menus.length == 0) {
        data.okTest = '完成';
        data.cancelVisible = true;
      }
    } else {
      if (data.workMenuVoList.menus.length > 0) {
        //日程
        popsStyle.top = '100px';
        data.workVisible = true;
        if (data.settingMenuVoList.menus.length == 0) {
          data.okTest = '完成';
          data.cancelVisible = true;
        }
      } else {
        if (data.settingMenuVoList.menus.length > 0) {
          //设置
          popsStyle.top = '7px';
          popsStyle.right = '248px';
          popsStyle.left = 'auto';
          popsStyle.width = '45px';
          data.setVisible = true;
        }
      }
    }
  }
};
// 对象菜单-点击下一步/完成
const menuOnOk = () => {
  if (data.okTest == '完成') {
    //完成
    onCancel();
  } else {
    data.menuVosVisible = false;
    if (data.workMenuVoList.menus.length > 0) {
      //日程
      popsStyle.top = 60 + data.dashMenuVoList.menus.length * 44 + data.entityMenuVoList.menus.length * 44 + 'px';
      data.workVisible = true;
      if (data.settingMenuVoList.menus.length == 0) {
        data.okTest = '完成';
        data.cancelVisible = true;
      }
    } else {
      if (data.settingMenuVoList.menus.length > 0) {
        //设置
        popsStyle.top = '7px';
        popsStyle.right = '248px';
        popsStyle.left = 'auto';
        popsStyle.width = '45px';
        data.setVisible = true;
      }
    }
  }
};
// 日程菜单-点击下一步/完成
const WorkerOnOk = () => {
  if (data.okTest == '完成') {
    //完成
    onCancel();
  } else {
    data.workVisible = false;
    popsStyle.top = '7px';
    popsStyle.right = '248px';
    popsStyle.left = 'auto';
    popsStyle.width = '45px';
    data.setVisible = true;
  }
};

const onCancel = () => {
  //跳过
  app.style.height = 'auto';
  app.style.overflow = 'auto';
  data.dashVisible = false;
  data.menuVosVisible = false;
  data.workVisible = false;
  data.maskVisible = false;
  data.popoverVisible = false;
  setLoginTimes(false); //保存是否是首次登陆
};
</script>
<style scoped lang="less">
@import './xl-guide.less';
</style>

<style lang="less">
.user-popover-popconfirm {
  .arco-popconfirm-popup-content {
    .arco-popconfirm-body {
      .arco-popconfirm-icon {
        display: none;
      }
    }

    .arco-popconfirm-footer {
      .arco-btn-size-mini {
        height: 32px;
        padding: 0 15px;
      }
    }
  }
}

.popover-popconfirm {
  .arco-btn-secondary {
    display: none;
  }
}
</style>
